// src/pages/NotFound.jsx
import React from "react";
import { Container, Typography, Button } from "@mui/material";
import { Link } from "react-router-dom";
import HomeIcon from '@mui/icons-material/Home';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

function NotFound() {
  return (
    <Container maxWidth="sm" sx={{ textAlign: "center", mt: 10 }}>
      <Typography variant="h2" gutterBottom>
        404
      </Typography>

      <Typography variant="h6" color="text.secondary" gutterBottom>
        The page you are looking for does not exist.
      </Typography>

      <Button
        component={Link}
        to="/"
        variant="outlined"
        color="primary"
        size="large"
        startIcon={<HomeIcon />}
        sx={{ mt: 3, mr: 2 }}
      >
        Go to Home
      </Button>

      <Button
        component={Link}
        to="/contact-us"
        variant="outlined"
        color="primary"
        size="large"
        startIcon={<ArrowBackIcon />}
        sx={{ mt: 3 }}
      >
        Contact Us
      </Button>
    </Container>
  );
}

export default NotFound;